import React from "react";
import "./style.css";
import {
  FaGithub,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaAngellist,
  FaMedium,
} from "react-icons/fa";
import { socialprofils } from "../../content_option";

export const Socialicons = (params) => {
  return (
    <div className="stick_follow_icon">
      <ul>
        {socialprofils.twitter && (
          <li>
            <a href={socialprofils.twitter} target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>
          </li>
        )}
        {socialprofils.github && (
          <li>
            <a href={socialprofils.github} target="_blank" rel="noopener noreferrer">
              <FaGithub />
            </a>
          </li>
        )}
        {socialprofils.Instagram && (
          <li>
            <a href={socialprofils.Instagram} target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
          </li>
        )}
        {socialprofils.linkedin && (
          <li>
            <a href={socialprofils.linkedin} target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
          </li>
        )}
        {socialprofils.wellfound && (
          <li>
            <a href={socialprofils.wellfound} target="_blank" rel="noopener noreferrer">
              <FaAngellist />
            </a>
          </li>
        )}
        {socialprofils.medium && (
          <li>
            <a href={socialprofils.medium} target="_blank" rel="noopener noreferrer">
              <FaMedium />
            </a>
          </li>
        )}
      </ul>
      <p>Follow Me</p>
    </div>
  );
};
